//  all, DSA Competitions, Competative Coding, Hackethrons, Open Source, Development, MNC Competitions, Global, Pan India, College Level, MAANG

export const competitionFilters = [
  {
    text: "All",
    id: 1,
  },
  {
    text: "DSA Competitions",
    id: 2,
  },
  {
    text: "Competitive Coding",
    id: 3,
  },
  {
    text: "Open Source",
    id: 4,
  },
  {
    text: "Development",
    id: 5,
  },
  {
    text: "Top Hackathons",
    id: 6,
  },
  {
    text: "Coding Events",
    id: 7,
  },
  {
    text: "Hiring",
    id: 8,
  },
  {
    text: "Top MNC Organised",
    id: 9,
  },
  {
    text: "Tier 1 College Organised",
    id: 10,
  },
  {
    text: "Group Competitions",
    id: 11,
  },
];
